var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_00000145049271370995700300000003487412756501951400_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1686 7.83145L13.2485 13.3303L4.9645 10.5686C4.38626 10.3755 3.99669 9.83294 4.00002 9.22344C4.00339 8.61395 4.39742 8.07476 4.97789 7.88836L26.1573 1.06782C26.6607 0.905979 27.2133 1.0388 27.5873 1.41278C27.9612 1.78676 28.0941 2.3393 27.9322 2.84277L21.1117 24.0221C20.9253 24.6026 20.3861 24.9966 19.7766 25C19.1671 25.0033 18.6246 24.6138 18.4314 24.0355L15.6563 15.7114L21.1686 7.83145Z",
    fill: "url(#paint0_linear_6215_27865)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6215_27865",
    x1: 4,
    y1: 25,
    x2: 28.0001,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3889FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F528CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.51726853.svg";
export { ForwardRef as ReactComponent };